import { createFilter } from "react-select";

// Our account/property options carry a JSX label (id chip + name), which react-select's
// default stringify renders to "[object Object]" — so only the id (in `value`) is searchable.
// Stringifying the displayName alongside the value restores name search next to id search.
export const filterByNameOrId = createFilter({
    stringify: ({ data, value }) => `${data.displayName} ${value}`,
});
